"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePagination = exports.SEPARATOR = void 0;
var common_utils_1 = require("../../tools/common-utils");
exports.SEPARATOR = -1;
var calculateAdjacentPages = function (size) {
    switch (size) {
        case 'base':
            return 1;
        case 'wide':
            return 2;
        case 'tight':
        default:
            return 0;
    }
};
var generatePagination = function (_a) {
    var totalItems = _a.totalItems, pageSize = _a.pageSize, currentPage = _a.currentPage, size = _a.size;
    var totalPages = Math.ceil(totalItems / pageSize);
    var adjacentPages = calculateAdjacentPages(size);
    var totalPageNumbers = adjacentPages + 5;
    var firstPageIndex = 1;
    var leftSiblingIndex = Math.max(currentPage - adjacentPages, 1);
    var rightSiblingIndex = Math.min(currentPage + adjacentPages, totalPages);
    var showLeftDots = leftSiblingIndex > 2;
    var showRightDots = rightSiblingIndex < totalPages - 2;
    if (totalItems <= pageSize) {
        return [firstPageIndex];
    }
    // < 1 2 3 4 5 >
    if (totalPageNumbers >= totalPages) {
        return (0, common_utils_1.range)(1, totalPages);
    }
    // < 1 ... 14 15 16 ... 100 >
    if (showLeftDots && showRightDots) {
        var middleRange = (0, common_utils_1.range)(leftSiblingIndex, rightSiblingIndex);
        return __spreadArray(__spreadArray([firstPageIndex, exports.SEPARATOR], middleRange, true), [exports.SEPARATOR, totalPages], false);
    }
    // < 1 2 3 4 ... 100 >
    if (!showLeftDots && showRightDots) {
        var leftRange = (0, common_utils_1.range)(1, 3 + 2 * adjacentPages);
        return __spreadArray(__spreadArray([], leftRange, true), [exports.SEPARATOR, totalPages], false);
    }
    // < 1 ... 97 98 99 100 >
    if (showLeftDots && !showRightDots) {
        var rightItemCount = 3 + 2 * adjacentPages;
        var rightRange = (0, common_utils_1.range)(totalPages - rightItemCount + 1, totalPages);
        return __spreadArray([firstPageIndex, exports.SEPARATOR], rightRange, true);
    }
    return [];
};
exports.generatePagination = generatePagination;
